import React, { FC } from 'react'
import { IconBaseProps } from 'react-icon-base'
import { StyledIcon } from './styled-icon'

export const CsSendIcon: FC<IconBaseProps> = (props) => (
  <StyledIcon viewBox="0 0 1024 1024" {...props}>
    <g>
      <path d="M1008 15.429q18.857 13.714 15.429 36.571L877.143 929.714q-2.857 16.571-18.286 25.714-8 4.571-17.714 4.571-6.286 0-13.714-2.857L568.572 851.428l-138.286 168.571q-10.286 13.143-28 13.143-7.429 0-12.571-2.286-10.857-4-17.429-13.429t-6.571-20.857V797.141l493.714-605.143-610.857 528.571-225.714-92.571q-21.143-8-22.857-31.429-1.143-22.857 18.286-33.714L969.144 14.284q8.571-5.143 18.286-5.143 11.429 0 20.571 6.286z" />
    </g>
  </StyledIcon>
)

CsSendIcon.displayName = 'CsSendIcon'
